import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import { setLocale } from "@/i18n";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/growth",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/GrowthRecord.vue"),
  },
  {
    path: "/work-scheduling/monthly",
    component: () => import("@/views/MonthlyWorkSchedule.vue"),
  },
  {
    path: '/work-scheduling/daily',
    component: () => import('@/views/DailyWorkSchedule.vue'),
  },
  {
    path: '/guidance-plan',
    component: () => import('@/views/GuidancePlan.vue'),
  },
  {
    path: "/child-development/analytics",
    component: () => import("@/views/ChildDevelopmentAnalytics.vue"),
  },
  {
    path: '/letter',
    component: () =>import('@/views/LetterDetail.vue'),
  },
  {
    path: "/child-development/child",
    component: () => import("@/views/ChildDevelopmentChild.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, _from, next) => {
  const localeQuery = to.query.locale;
  if (typeof localeQuery === 'string') {
    setLocale(localeQuery);
  }
  next();
});

export default router;
